import { Directive, ElementRef, Inject, Injector } from "@angular/core";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    standalone: false,
    selector: 'ng1-app'
})
export class Ng1AppComponentWrapper extends UpgradeComponent {
    constructor(@Inject(ElementRef) elementRef: ElementRef,@Inject(Injector) injector: Injector){
        super('ng1App',elementRef,injector);
    }
}